export default __webpack_public_path__ + "static/media/LogoPDF.6570a240.png";